import { Helmet } from "react-helmet-async";
import routes from "../data/route-metas.json"
import { imgSrc } from "../utils/backend";

type MetaProp = {
    title: string
    url: string
    description?: string
    splash: string
}

type props = {
  path?: string,
  meta?: MetaProp
}

export function MetaProps(props: props) {
  const path = props.path?.replace("/", "");
  const route = props.meta ?? routes.find(r => path?.startsWith(r.url))
  
  if (!route) return (<></>)

  return (
    <Helmet>
      <title>LDS Gamers - {route.title}</title>

      <meta property="og:url" content={`${process.env.REACT_APP_FRONTEND}/${route.url}`}/>
      <meta property="og:title" content={`LDS Gamers ${route.title}`}/>
      <meta property="og:site_name" content="LDS Gamers Profile"/>
      <meta property="og:image" content={imgSrc(`splash/${route.splash ?? "bday"}.jpg`)}/>

      {route.description && <meta property="og:description" content={route.description}/> }
    </Helmet>
  )
}